import InstaIcon from '../../images/insta.png';
import FhIcon from '../../images/fhkung.png';

export function Contact() {
    return (
        <div className='card' id='contact'>
            <h2 >Fale Conosco</h2>
            <section className="contact">
                
                <div className="map">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3646.2597490215408!2d-46.3294955257319!3d-23.951253378533846!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce0370da062b3f%3A0x69414964f1ba45a4!2sRep%C3%BAblica%20do%20Boxe!5e0!3m2!1spt-BR!2sbr!4v1750639175745!5m2!1spt-BR!2sbr" width="600" height="450" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div>
                <div className="contact-info">
                    <p>Rua Doutor Carvalho de Mendonça, 379 - 2º andar - Santos</p>
                    <a href="https://www.instagram.com/republicadoboxe/" target='_blank' rel="noreferrer">
                        <img className='icon' src={InstaIcon} alt="Ícone do instagram que encaminha para a página da República do Boxe" />
                    </a>
                    <a href="https://fhkungfu.com/" target='_blank' rel="noreferrer">
                        <img className='icon fh-icon' src={FhIcon} alt="Ícone que encaminha para o site da academia Feng Huan de Kung Fu" />
                    </a> 
                </div>
                
            </section>
        </div>
        
    )
}